export default "__VITE_ASSET__Ddic9D1E__"